export default __webpack_public_path__ + "static/media/guide_05.f75e1705.png";